import { Route, Switch, Redirect } from "react-router-dom";
import React, { useState } from 'react';
import PublicHeader from "./Component/Common/Header/Public";
import PublicFooter from "./Component/Common/Footer/Public";
import PrivateHeader from "./Component/Common/Header/Private";
import WebViewSideBar from "./Component/Common/Sidebar/Web";
import MobileViewSideBar from "./Component/Common/Sidebar/Mobile";



import Login from "./pages/Auth/Login";
import Register from "./pages/Auth/Register";

import Dashboard from "./pages/Dashboard/index";
import PostOppurtunity from "./pages/Oppurtunity/Post";
import KycForm from "./pages/KYC/form";
import RecruiterGuidelines from "./pages/RecruiterGuidlines/index";
import UserList from "./pages/ManageUser";
import DatabaseSearch from './pages/DatabaseSearch'
import DatabaseSearchList from './pages/DatabaseSearch/List'
import OppurtunityApplications from './pages/Oppurtunity/Applications'
import ProfilePreview from './pages/CompanyProfile/viewProfile'
import ProfileEdit from './pages/CompanyProfile/editProfile'
import GenerateOfferLetter from './pages/GenerateOfferLetter/index'
import OnlineSalesEnquiry from './pages/Enquiry/sales'







import Header from "./old_Components/Common/Header";
import HeaderAfterLogin from "./old_Components/Common/HeaderAfterLogin";
import Footer from "./old_Components/Common/Footer";
import register from "./old_pages/Register/Register";
import PrRegister from "./old_pages/Register/PrRegister";
// import OnlineSalesEnquiry from "./old_pages/SalesEnquiry/OnlineSalesEnquiry";
import ForgotPassword from "./old_pages/ForgotPassword/ForgotPassword";
// import JobPosting from "./old_Components/Products/JobPosting";
import ResetPassword from './old_pages/ForgotPassword/resetPassword';
//import Dashboard from "./old_Components/Dashboard/Dashboard";
// import Dashboard from "./pages/Dashboard";
import EditProfile from "./old_pages/EditProfile/EditProfile";
import PostARegularJob from "./old_pages/PostJob/PostARegularJob";
import PostAJob from "./old_pages/PostAJob";

// import JobList from "./old_pages/JobList/JobList";
import JobList from "./old_pages/JobList/New";

import PostAFeaturedJob from "./old_pages/PostJob/PostAFeaturedJob";
import PostAPremiumJob from "./old_pages/PostJob/PostAPremiumJob";
import constant from "./constant";
import Package from './old_pages/Package/package';
import JobPackage from './old_pages/Package/JobPackage';
import Logout from "./old_Components/Common/Logout";
import { getStorage } from "./utils";
import JobApplicationList from "./old_pages/JobApplicationList/JobApplicationList";
import OldKycForm from './old_pages/kyc/update';
import EditJob from "./old_pages/PostJob/EditJob";
import ViewProfile from "./old_Components/EditProfile/ViewProfile";
import Page404 from "./old_pages/Page404/Page404";
import LOI from "./old_Components/JobApplicationList/LOI";
import ChangePassword from "./old_pages/ChangePassword/ChangePassword";
import ThankYou from "./old_Components/ThankYou/ThankYou";
import Settings from "./old_pages/Settings/Settings";
// import Security from './old_pages/SecurityCode/Securitycode';
// import UpdatePin from "./old_Components/Settings/UpdatePin";
// import ManageSubusers from "./old_pages/ManageSubusers/ManageSubusers";
import UserCreate from "./old_pages/ManageSubusers/UserCreate";
// import UserList from "./old_pages/ManageSubusers/UserList"
// import PackageSuccessfullySubscribed from './old_Components/Package/ThankYou'
// import UserList from "./old_pages/ManageSubusers/UserList";
import SuccessPayment from "./old_Components/Package/SuccessPayment";
import PaymentFailse from "./old_Components/Package/PaymentFailse";
import PaymentProcessing from "./old_pages/Package/PaymentStatus";
import Onboard from "./old_pages/ATS/onboard";
import UserUpdate from "./old_pages/ManageSubusers/UserUpdate";
import ContactUs from "./old_Components/Common/ContactUs";
import TransactionHistory from "./old_pages/TransactionHistory/TransactionHistory";
import TransactionInvoice from "./old_Components/TransactionHistory/TransactionInvoice";
// import registrationAndPayment from "./old_pages/registrationAndPayment/index"
// import registrationAndPaymentMiddleware from "./old_pages/registrationAndPayment/middleware";
// import Reward from "./old_pages/Rewards/Reward";
import SearchCandidate from "./old_pages/ATS/candidateSearch"
import AddNewCandidate from './old_pages/ATS/AddNewCandidate'
import PostACampusJob from './old_pages/Campus/PostJob'
import PostInternship from './old_pages/Campus/PostInternship'

import CampusInternshipList from './old_pages/Campus/InternshipList'
import CampusJobList from './old_pages/Campus/JobList'
import CampusJobApplicationList from "./old_pages/Campus/JobApplicationList";
import CampusInternshipApplicationList from "./old_pages/Campus/InternshipApplicationList";

import EditCampusJob from './old_pages/Campus/EditJob'
import EditCampusInternship from './old_pages/Campus/EditInternship'
import MainHeader from "./old_Components/Common/MainHeader";
import MainFooter from "./old_Components/Common/MainFooter";
import DashboardHeader from "./old_Components/Common/DashboardHeader";
import JobPost from "./old_pages/JobPost/JobPost";
import JobHeader from "./old_Components/Common/JobHeader";
import Newtwo from "./old_pages/JobList/Newtwo";
import Newthree from "./old_pages/JobList/Newthree";
import Newfour from "./old_pages/JobList/Newfour";
import Newfive from "./old_pages/JobList/Newfive";
import Newsix from "./old_pages/JobList/Newsix";
import newkyc from "./old_pages/JobList/newkyc";
import neweditprofile from "./old_pages/JobList/neweditprofile";
import neweight from "./old_pages/JobList/neweight";
import newnine from "./old_pages/JobList/newnine";


const PrivateRoutes = (props) => {
    const token = getStorage(constant.keys.token);
    const urlKeys = Object.entries(constant.component);
    const path = props.path;
    const match = urlKeys.find((i) => i[1].url === path);

    // State for sidebar collapse (must be called unconditionally)
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(props.hideHeader);

    // Redirect logic
    if (!token) {
        return <Redirect to={constant.component.login.url} />;
    }

    if (!match) {
        return <Redirect to={constant.component.dashboard.url} />;
    }

    return (
        <React.Fragment>
            {/* Header */}
            {!props.hideHeader && <PrivateHeader />}

            {/* Sidebar */}
            {!props.hideSidebar && (
                <>
                    <WebViewSideBar
                        isSidebarCollapsed={isSidebarCollapsed}
                        setIsSidebarCollapsed={setIsSidebarCollapsed}
                    />
                </>
            )}

            {/* Route */}
            {!props.hideHeader ? <div className={`main-content rightbar  ${isSidebarCollapsed ? 'expanded' : ''} mt-4`}>
                <Route exact path={props.path} component={props.component} />
            </div>
                :
                <Route exact path={props.path} component={props.component} />

            }            {!props.hideSidebar && (
                <>
                    <MobileViewSideBar
                        isSidebarCollapsed={isSidebarCollapsed}
                        setIsSidebarCollapsed={setIsSidebarCollapsed}
                    />
                </>
            )}

        </React.Fragment>
    );
};



const JobpostRoutes = (props) => {
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

    return (
        <React.Fragment>
            {/* Header */}
            {!props.hideHeader && <PrivateHeader />}

            {/* Sidebar */}
            {!props.hideSidebar && (
                <>
                    <WebViewSideBar
                        isSidebarCollapsed={isSidebarCollapsed}
                        setIsSidebarCollapsed={setIsSidebarCollapsed}
                    />
                </>
            )}

            {/* Route */}
            <div className={`main-content rightbar  ${isSidebarCollapsed ? 'expanded' : ''} mt-4`}>
                <Route exact path={props.path} component={props.component} />
            </div>
            {!props.hideSidebar && (
                <>
                    <MobileViewSideBar
                        isSidebarCollapsed={isSidebarCollapsed}
                        setIsSidebarCollapsed={setIsSidebarCollapsed}
                    />
                </>
            )}

        </React.Fragment>
    );
}


const AdminRoutes = (props) => {
    const token = getStorage(constant.keys.token)
    const urlKeys = Object.entries(constant.component);
    const path = props.path;
    const match = urlKeys.filter((i) => i[1].url === path);
    if (token) {
        if (match.length > 0 && match[0][1].url === path) {
            return (
                <React.Fragment>
                    {
                        props.hideHeader === true ? null : <HeaderAfterLogin />
                    }

                    <Route exact={true} path={props.path} component={props.component} />

                    {
                        props.hideFooter === true ? null : <Footer />
                    }

                </React.Fragment>
            )
        }
        else {
            window.location.href = constant.component.login.url
        }

    }
    else {
        window.location.href = constant.component.login.url
    }

}


const PublicRoutes = (props) => {

    const token = getStorage(constant.keys.token)
    const urlKeys = Object.entries(constant.component);
    const path = props.path;
    const match = urlKeys.filter((i) => i[1].url === path);
    if (!token) {
        if (match.length > 0 && match[0][1].url === path) {
            return (
                <React.Fragment>
                    {
                        props.hideHeader === true ? null : <PublicHeader />
                    }

                    <Route exact={true} path={props.path} component={props.component} />

                    {
                        props.hideFooter === true ? null : <PublicFooter />
                    }

                </React.Fragment>
            )
        }
        else {
            return <Redirect to={constant.component.login.url} />;
        }

    }
    else {
        return <Redirect to={constant.component.dashboard.url} />;

    }

}

const Router = () => {
    return (
        <React.Fragment>
            <Switch>

                <PublicRoutes exact path={constant.component.login.url} component={Login} />
                <PublicRoutes exact path={constant.component.register.url} hideFooter={true} component={Register} />

                <PrivateRoutes exact path={constant.component.dashboard.url}
                    hideFooter={true}
                    component={Dashboard} />

                <PrivateRoutes exact path={constant.component.postOppurtunity.url}
                    hideFooter={true}
                    hideHeader={true}
                    hideSidebar={true}
                    component={PostOppurtunity} />

                <PrivateRoutes exact path={constant.component.kycForm.url}
                    hideFooter={false}
                    hideHeader={false}
                    hideSidebar={false}
                    component={KycForm} />

                <PrivateRoutes exact path={constant.component.RecruiterGuidelines.url}
                    hideFooter={false}
                    hideHeader={false}
                    hideSidebar={false}
                    component={RecruiterGuidelines} />

                <PrivateRoutes exact path={constant.component.UserList.url}
                    hideFooter={false}
                    hideHeader={false}
                    hideSidebar={false}
                    component={UserList} />
                <PrivateRoutes exact path={constant.component.databaseSearch.url}
                    hideFooter={false}
                    hideHeader={false}
                    hideSidebar={false}
                    component={DatabaseSearch} />
                <PrivateRoutes exact path={constant.component.databaseSearchList.url}
                    hideFooter={false}
                    hideHeader={false}
                    hideSidebar={false}
                    component={DatabaseSearchList} />
                <PrivateRoutes exact path={constant.component.OppurtunityApplications.url}
                    hideFooter={false}
                    hideHeader={false}
                    hideSidebar={false}
                    component={OppurtunityApplications} />

                <PrivateRoutes exact path={constant.component.viewProfile.url}
                    hideFooter={false}
                    hideHeader={false}
                    hideSidebar={false}
                    component={ProfilePreview} />
                <PrivateRoutes exact path={constant.component.EditProfile.url}
                    hideFooter={false}
                    hideHeader={false}
                    hideSidebar={false}
                    component={ProfileEdit} />
                <PrivateRoutes exact path={constant.component.generateOffer.url}
                    hideFooter={false}
                    hideHeader={false}
                    hideSidebar={false}
                    component={GenerateOfferLetter} />
                <PublicRoutes exact path={constant.component.OnlineSalesEnquiry.url} component={OnlineSalesEnquiry} />
                
                <Route exact path={constant.component.logout.url} component={Logout} />




                <AdminRoutes exact path={constant.component.campusInternshipList.url} component={CampusInternshipList} />
                <AdminRoutes exact path={constant.component.campusJobList.url} component={CampusJobList} />
                <AdminRoutes exact path={constant.component.CampusJobApplicationList.url} component={CampusJobApplicationList} />
                <AdminRoutes exact path={constant.component.CampusInternshipApplicationList.url} component={CampusInternshipApplicationList} />

                <AdminRoutes exact path={constant.component.EditCampusJob.url} component={EditCampusJob} />
                <AdminRoutes exact path={constant.component.EditInternship.url} component={EditCampusInternship} />


                <AdminRoutes exact path={constant.component.PostACampusJob.url} component={PostACampusJob} />
                <AdminRoutes exact path={constant.component.PostInternship.url} component={PostInternship} />

                <AdminRoutes exact path={constant.component.onBoardCandidate.url} component={Onboard} />
                <AdminRoutes exact path={constant.component.candidateSearch.url} component={SearchCandidate} />
                <AdminRoutes exact path={constant.component.addCandidate.url} component={AddNewCandidate} />

                {/* <PrivateRoutes exact path={constant.component.registrationAndPayment.url} component={registrationAndPayment} /> */}
                {/* <PrivateRoutes exact path={constant.component.registrationAndPaymentMiddleware.url} component={registrationAndPaymentMiddleware} /> */}


                {/* <PublicRoutes exact path={constant.component.Register.url} component={register} /> */}
                <JobpostRoutes exact path={constant.component.JobPost.url} component={JobPost} />
                <PublicRoutes exact path={constant.component.PrRegister.url} component={PrRegister} />
                <PublicRoutes exact path={constant.component.Register.url} component={register} />
                <PrivateRoutes exact path={constant.component.ForgotPassword.url} component={ForgotPassword} />
                {/* <PrivateRoutes exact path={constant.component.JobPosting.url} component={JobPosting} /> */}
                <PublicRoutes exact path={constant.component.resetPassword.url} component={ResetPassword} />
                <PrivateRoutes exact path={constant.component.JobPosting.url} component={JobPackage} />
                <AdminRoutes exact path={constant.component.JobPackage.url} component={JobPackage} />
                <AdminRoutes exact path={constant.component.TransactionHistory.url} component={TransactionHistory} />
                <AdminRoutes exact path={constant.component.TransactionInvoice.url} component={TransactionInvoice} />

                {/* <Route exact path={constant.component.BuyPackage.url} component={BuyPackage} /> */}
                <AdminRoutes exact path={constant.component.package.url} component={Package} />

                <AdminRoutes exact path={constant.component.PostAJob.url} component={PostAJob} />

                <AdminRoutes exact path={constant.component.PostARegularJob.url} component={PostARegularJob} />
                <AdminRoutes exact path={constant.component.PostAFeaturedJob.url} component={PostAFeaturedJob} />
                <AdminRoutes exact path={constant.component.PostAPremiumJob.url} component={PostAPremiumJob} />
                <AdminRoutes exact path={constant.component.EditProfile.url} component={EditProfile} />
                <AdminRoutes exact path={constant.component.updateKyc.url} component={OldKycForm} />
                <JobpostRoutes exact path={constant.component.JobList.url} component={JobList} />
                <JobpostRoutes exact path={'/newtwo'} component={Newtwo} />
                <JobpostRoutes exact path={'/newthree'} component={Newthree} />
                <JobpostRoutes exact path={'/newfour'} component={Newfour} />
                <JobpostRoutes exact path={'/newfive'} component={Newfive} />
                <JobpostRoutes exact path={'/newsix'} component={Newsix} />
                <JobpostRoutes exact path={'/newkyc'} component={newkyc} />
                <JobpostRoutes exact path={'/newseven'} component={neweditprofile} />
                <JobpostRoutes exact path={'/neweight'} component={neweight} />
                <JobpostRoutes exact path={'/newnine'} component={newnine} />
                <AdminRoutes exact path={constant.component.editJob.url} component={EditJob} />
                {/* <AdminRoutes exact path={constant.component.viewProfile.url} component={ViewProfile} /> */}
                <AdminRoutes exact path={constant.component.JobApplicationList.url} component={JobApplicationList} />
                {/* <Route exact={true} path={constant.component.logout.url} component={Logout} /> */}
                {/* <Route exact path={constant.component.zoomMeeting.url} component={Zoom} /> */}
                {/* <PrivateRoutes exact path={constant.component.directjobpost.url} component={DirectPost} /> */}
                <PrivateRoutes exact path={constant.component.ThankYou.url} component={ThankYou} />

                {/* <PrivateRoutes exact path={constant.component.Page404.url} component={Page404} /> */}
                <AdminRoutes exact path={constant.component.LOI.url} component={LOI} />
                {/* <AdminRoutes exact path={constant.component.ChangePassword.url} component={ChangePassword} /> */}
                <AdminRoutes exact path={constant.component.Settings.url} component={Settings} />
                {/* <AdminRoutes exact path={constant.component.updateSecurityCode.url} component={Security} /> */}
                {/* <AdminRoutes exact path={constant.component.UpdatePin.url} component={UpdatePin} /> */}
                <AdminRoutes exact path={constant.component.ChangePassword.url} component={ChangePassword} />
                {/* <AdminRoutes exact path={constant.component.ManageSubusers.url} component={ManageSubusers} /> */}
                <AdminRoutes exact path={constant.component.UserCreate.url} component={UserCreate} />
                {/* <AdminRoutes exact path={constant.component.UserList.url} component={UserList} /> */}
                <AdminRoutes exact path={constant.component.UserUpdate.url} component={UserUpdate} />
                {/* <AdminRoutes exact path={constant.component.successfullyPackagePurchased.url} component={PackageSuccessfullySubscribed} /> */}
                <AdminRoutes exact path={constant.component.SuccessPayment.url} component={SuccessPayment} />
                <AdminRoutes exact path={constant.component.PaymentFailse.url} component={PaymentFailse} />
                <AdminRoutes exact path={constant.component.PaymentProcessing.url} component={PaymentProcessing} />
                <AdminRoutes exact path={constant.component.contactUs.url} component={ContactUs} />
                {/* <AdminRoutes exact path={constant.component.eventCalender.url} component={EventCalender} /> */}
                {/* <AdminRoutes exact path={constant.component.futureHiringList.url} component={FutureHiringList} /> */}
                <Route component={Page404} />

            </Switch>

        </React.Fragment>

    )
}


export default Router;